import styled from '@emotion/styled'
import { ErrorListProps } from 'antd/lib/form/ErrorList'
import { Form } from '../../Form'

export const ErrorList = ({ ...props }: ErrorListProps) => {
  return <FormErrorList {...props} />
}

const FormErrorList = styled(Form.ErrorList)`
  margin-bottom: 16px;

  & div.-item-explain-error {
    color: ${props => props.theme.red5};
    display: list-item;
    list-style-type: disc;
    list-style-position: inside;
  }
`
